import { AuthLogin } from 'shared/interfaces';
import { getCookie, removeCookie, setCookie } from 'utils/helpers';

const userLoginRememberMeCookieKey = 'pet_rememberMe';
const userLoginRememberMeCookieExpirationDays = 5;

export const userRememberMeCookie = {
  set(values: AuthLogin) {
    const encodeCookie = btoa(JSON.stringify(values));

    setCookie(
      userLoginRememberMeCookieKey,
      encodeCookie,
      userLoginRememberMeCookieExpirationDays
    );
  },
  get() {
    const cookie = getCookie(userLoginRememberMeCookieKey);

    if (cookie) {
      const decodeCookie = JSON.parse(atob(cookie));

      return decodeCookie;
    }

    return false;
  },
  remove() {
    removeCookie(userLoginRememberMeCookieKey);
  },
};
